<template>
  <main
    :class="`home-page fade-in-fwd ${
      isMenuOpen ? 'isMenuOpenPadding' : 'isMenuClosePadding'
    }`"
  >
    <div class="w-full flex flex-col gap-2 py-4 md:py-4 md:px-4">
      <div
        class="bg-gradient-to-r from-blue-700 via-indigo-800 to-purple-900 rounded-2xl p-6 sm:p-8 text-white shadow-xl mb-6"
      >
        <div class="flex items-center gap-4 mb-3">
          <div
            class="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-2xl"
          >
            <i class="fa-solid fa-rotate text-yellow-300"></i>
          </div>
          <div>
            <h1 class="text-2xl sm:text-3xl font-bold tracking-tight m-0">
              Instant & Crash Spins
            </h1>
            <p class="text-indigo-200 text-sm m-0 mt-1">
              Live rounds, multiplier crash points, and bet settlements
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm">
        <div
          class="flex items-center justify-between mb-4 pb-3 border-b border-slate-100"
        >
          <div class="flex items-center gap-2">
            <i class="fa-solid fa-list-check text-indigo-600"></i>
            <h3 class="font-bold text-slate-800 text-lg m-0">
              Live Spins & Rounds
            </h3>
          </div>
        </div>

        <RoundFinder />
      </div>
    </div>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import RoundFinder from "@/slot/components/round/RoundFinder.vue";

const store = useStore();
const isMenuOpen = computed(() => store.state.isMenuOpen);
</script>

<style scoped></style>
